module.exports = __webpack_public_path__ + "images/SelectField-arrow-BYwTK40.svg";